angular.module('bizmetryApp').service('ClientService', [
  '$http', 'CONFIG',
  function ($http, CONFIG) {

    const BASE = CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-client';

    function getAccountId() {
      try {
        const user = JSON.parse(sessionStorage.getItem('user'));
        return user && user.id ? user.id : null;
      } catch (e) {
        return null;
      }
    }

    function getBearer() {
      return (
        sessionStorage.getItem('access_token') ||
        sessionStorage.getItem('token') ||
        (JSON.parse(sessionStorage.getItem('user') || '{}').token) ||
        null
      );
    }

    function baseHeaders() {
      return { 'X-User-Account-Id': getAccountId() };
    }

    function authHeaders() {
      const h = baseHeaders();
      const bearer = getBearer();
      if (bearer) h['Authorization'] = bearer.startsWith('Bearer ') ? bearer : `Bearer ${bearer}`;
      return h;
    }

    // ======================
    // LIST BY PROFILE
    // GET /profile/{profileId}/clients
    // Soporta: page, size, search, clientType, sort
    // ======================
    this.listClientsByProfile = function (profileId, options = {}) {
      const params = {
        page: options.page !== undefined ? options.page : 0,
        size: options.size !== undefined ? options.size : 10
      };

      if (options.search) params.search = options.search;
      if (options.clientType) params.clientType = options.clientType;
      if (options.sort) params.sort = options.sort;

      return $http.get(
        `${BASE}/profile/${profileId}/clients`,
        { headers: authHeaders(), params }
      );
    };

    // ======================
    // GET CLIENT TYPES BY PROFILE
    // GET /profile/{profileId}/clients/types
    // Returns distinct client types instantiated in this profile
    // ======================
    this.getClientTypesByProfile = function (profileId) {
      return $http.get(
        `${BASE}/profile/${profileId}/clients/types`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // GET ONE
    // GET /profile/{profileId}/clients/{clientId}
    // ======================
    this.getClientById = function (profileId, clientId) {
      return $http.get(
        `${BASE}/profile/${profileId}/clients/${clientId}`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // CREATE
    // POST /profile/{profileId}/clients
    // ======================
    this.createClient = function (profileId, payload) {
      return $http.post(
        `${BASE}/profile/${profileId}/clients`,
        payload,
        { headers: authHeaders() }
      );
    };

    // ======================
    // PATCH
    // PATCH /profile/{profileId}/clients/{clientId}
    // ======================
    this.patchClient = function (profileId, clientId, payload) {
      return $http.patch(
        `${BASE}/profile/${profileId}/clients/${clientId}`,
        payload,
        { headers: authHeaders() }
      );
    };

    // ======================
    // DELETE
    // DELETE /profile/{profileId}/clients/{clientId}
    // ======================
    this.deleteClient = function (profileId, clientId) {
      return $http.delete(
        `${BASE}/profile/${profileId}/clients/${clientId}`,
        { headers: authHeaders() }
      );
    };

    // ======================
    // BULK DELETE
    // DELETE /profile/{profileId}/clients/bulk
    // ======================
    this.bulkDeleteClients = function (profileId, clientIds) {
       const headers = authHeaders();
  headers['Content-Type'] = 'application/json';
      return $http({
        method: 'DELETE',
        url: `${BASE}/profile/${profileId}/clients/byIds`,
        headers: headers,
        data: { clientIds: clientIds }
      });
    };

  }
]);